<template>
    <div class="pt-0">
        <div>
            <b-row align-h="start" align-v="center">
                <b-col cols="12" class="pr-0 pb-2">
                    <h2 style="color: #12576e;">Pagamento:</h2>
                </b-col>
            </b-row>

            <div>
                <b-card no-body border-variant="light" style="margin-top: 0%; margin-bottom: 1%; padding: 1%;" footer-bg-variant="secondary">
                    <b-row align-h="start" align-v="center">
                        <b-col cols="4">
                            <b-form-group label="Forma de pagamento" label-class="small">
                                <b-form-select v-model="output_transaction.payment.payment_method" :class="output_transaction.payment.payment_method.name != '' ? '' : 'is-invalid'" required>
                                    <template #first>
                                        <b-form-select-option :value="{ index: null, name: '' }" disabled>Selecione a forma de pagamento</b-form-select-option>
                                    </template>

                                    <b-form-select-option v-for="(payment_method_index, payment_method_name) in paymentMethods" :value="{ index: payment_method_index, name: payment_method_name }" :key="payment_method_index">
                                        {{ payment_method_name }}
                                    </b-form-select-option>
                                </b-form-select>
                            </b-form-group>
                        </b-col>

                        <b-col cols="4">
                            <b-form-group label="Valor do pagamento" label-class="small">
                                <CurrencyBaseInput v-model="output_transaction.payment.value" :modelValue="Number(output_transaction.payment.value)" :isPercentage="false"
                                    :options="currencyOptions" @keyup="updatePaymentValue($event)" placeholder="R$ 0,00">
                                </CurrencyBaseInput>
                            </b-form-group>
                        </b-col>

                        <b-col cols="4">
                            <b-form-group label="Data do pagamento" label-class="small">
                                <date-picker v-model="output_transaction.payment.date" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" class="w-100" :clearable="false" required>
                                </date-picker>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row align-h="start" align-v="center">
                        <b-col cols="4">
                            <b-form-group label="CV" label-class="small">
                                <b-form-input v-model="output_transaction.payment.cv" placeholder="Digite o CV do pagamento"></b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col cols="4">
                            <b-form-group label="AUT" label-class="small">
                                <b-form-input v-model="output_transaction.payment.aut" placeholder="Digite o AUT do pagamento"></b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col cols="4">
                            <b-form-group label="ID Pix" label-class="small">
                                <b-form-input v-model="output_transaction.payment.pix_id" placeholder="Digite o ID Pix do pagamento"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row align-h="start" align-v="center">
                        <b-col cols="4">
                            <b-form-group label="Nota Fiscal NF" label-class="small">
                                <b-form-input v-model="output_transaction.payment.invoice_number" placeholder="Nota Fiscal"></b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col cols="4">
                            <b-form-group label="Nome do fornecedor" label-class="small">
                                <b-form-input v-model="output_transaction.payment.supplier_name" placeholder="Fornecedor"></b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col cols="4">
                            <b-form-group label="Documento do fornecedor" label-class="small">
                                <b-form-input v-model="output_transaction.payment.supplier_document" maxlength="18" placeholder="CPF, CNPJ ou Passaporte"
                                    v-mask="getDocMask(output_transaction.payment.supplier_document)"
                                    @keyup="output_transaction.payment.supplier_document = String(output_transaction.payment.supplier_document || '').toUpperCase()">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card>
            </div>

            <hr>

            <div>
                <b-row align-h="start" align-v="center">
                    <b-col cols="6" class="pr-0">
                        <h2 style="color: #12576e;">Informações gerais:</h2>
                    </b-col>
                </b-row>

                <b-row align-h="start" align-v="center">
                    <b-col cols="6">
                        <b-form-group label="Rótulo" label-class="small">
                            <b-form-input v-if="generalLabelOptions.length == 0" v-model="output_transaction.general.label"
                                :class="output_transaction.general.label != '' ? '' : 'is-invalid'" placeholder="Rótulo" required>
                            </b-form-input>

                            <b-form-select v-else v-model="output_transaction.general.label" :class="output_transaction.general.label != '' ? '' : 'is-invalid'" required>
                                <template #first>
                                    <b-form-select-option :value="''" disabled>Selecione o rótulo</b-form-select-option>
                                </template>

                                <b-form-select-option v-for="(label, label_index) in generalLabelOptions" :value="label" :key="label_index">
                                    {{ label }}
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label="Data prevista" label-class="small">
                            <date-picker v-model="output_transaction.general.date" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" class="w-100" :clearable="false" required>
                            </date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row align-v="center">
                    <b-col cols="12">
                        <b-form-group label="Observações" label-class="small">
                            <b-form-textarea v-model="output_transaction.general.observation" placeholder="Adicione informações extras"></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row align-h="start" align-v="center">
                    <b-col cols="6">
                        <b-form-group label="Colaborador" label-class="small">
                            <b-form-input v-model="output_transaction.general.user.name" disabled placeholder="Nome do colaborador"></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                        <b-form-group label="Valor total" label-class="small">
                            <CurrencyBaseInput v-model="output_transaction.payment.value" :modelValue="Number(paymentsTotalValue)" disabled
                                :options="currencyOptions" placeholder="R$ 0,00" :isPercentage="false">
                            </CurrencyBaseInput>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { DatePicker } from "element-ui"
import { mapActions, mapGetters } from 'vuex';
import { VueMaskDirective } from 'v-mask'
import CurrencyBaseInput from '../../components/Inputs/CurrencyBaseInput.vue';

export default {
    name: 'OutputTransactionForm',

    components: {
        DatePicker,
        CurrencyBaseInput,
    },

    directives: { mask: VueMaskDirective },

    props: {
    },

    computed: {
        ...mapGetters('financeiro', {
            output_transaction: 'getOutputTransaction',
        }),

        ...mapGetters('product', {
            poisList: 'getPois',
        }),

        ...mapGetters('auth', {
            user: 'user',
            place: 'getPlace'
        }),

        xfields(){ return JSON.parse(this.place.xfields) },

        paymentsTotalValue(){ return this.output_transaction.payment.value },

        paymentMethods() {
            let paymentMethods = {}
            Object.entries(this.user.paymentMethods).sort(function (curr, prev) { return prev[1] < curr[1] }).forEach((pm) => { paymentMethods[pm[1]] = pm[0] })
            return paymentMethods
        },

        disabledSaveButton() {
            var disabled = (this.output_transaction.payment.value == 0)
            this.$emit('emitDisabledSaveButton', disabled);
            return disabled
        },

        generalLabelOptions() {
            var options = []
            console.log('transaction_third_options', this.place)
            var transaction_third_options = this.xfields.transaction_third_options
            if (transaction_third_options) {
                options = Object.values(transaction_third_options.label.split(',')).sort().filter(i => i != "")
            }
            return options
        },
    },

    watch: {
        disabledSaveButton(newValue, oldValue) {
            if (newValue) {
                this.$notify({ message: 'O valor total de pagamentos não pode estar zerado.', duration: 3000, type: 'warning' })
            }
        }
    },

    data() {
        return {
            currencyOptions: {
                locale: "pt-BR", currency: "BRL", currencyDisplay: "symbol", precision: 2,
                hideCurrencySymbolOnFocus: false, hideGroupingSeparatorOnFocus: false, hideNegligibleDecimalDigitsOnFocus: false,
                autoDecimalDigits: true, useGrouping: false, accountingSign: false
            },
        }
    },

    methods: {
        ...mapActions('financeiro', [
        ]),

        getDocMask(value) {
            const doc = String(value || '')
            if (/[A-Za-z]/.test(doc)) return 'AA######'
            const digits = doc.replace(/\D/g, '')
            if (digits.length > 11) return '##.###.###/####-##'
            return '###.###.###-##'
        },

        formatCurrency(value) {
            const numero = Number(value)
            return numero.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },

        //METHOD TO GROUP BY KEYGETTER.
        //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
        groupBy(list, keyGetter) {
            const map = new Map();
            list.forEach((item) => {
                const key = keyGetter(item);
                const collection = map.get(key);

                if (!collection) { map.set(key, [item]); }
                else { collection.push(item); }
            });
            return Array.from(map);
        },

        updatePaymentValue(event) { this.output_transaction.payment.value = event },
    },

    mounted() {
        if (this.output_transaction.general.id == null) {
            this.output_transaction.general.user = { uuid: this.user.uuid, name: this.user.name }
            this.output_transaction.general.date = moment().format('YYYY-MM-DD')
        }
    },

}
</script>
